<div *ngIf="profile?.profileImage!=null; else fallbackImage" [style.background-image]="profile?.profileImage.safe"
  [class.company_profile]="is_cp">
</div>
<ng-template #fallbackImage>
  <div class="fallbackImage" [class.company-profile]="getIsCompanyProfileFallbackImage">
    <i *ngIf="!getIsCompanyProfileFallbackImage" class="fal fa-user"></i>
    <i *ngIf="getIsCompanyProfileFallbackImage" class="fal fa-building company-profile-fallback-image"></i>
  </div>
</ng-template>